import React, { useCallback, useMemo } from "react";
import { Box } from "@mui/material";
import { MultiSelectContextMenu } from "components/common";
import moduleStyles from "../../../../v2/views/Inbox/Utilities/Styles.module.css";
import BasicFilterSelect from "../../../../v2/common/BasicFilterSelect";
import DateRangeForm from "../../../../v2/common/DateRangeForm";
import BasicButton from "../../../../v2/common/BasicButton";

const MESSAGE_DIRECTION_OPTIONS = [
  { name: "All", id: "ALL" },
  { name: "Incoming", id: "INCOMING" },
  { name: "Outgoing", id: "OUTGOING" },
];

function FilterForm({
  startDate,
  channelsAction,
  endDate,
  channelsFilter,
  channelsIds,
  direction = "ALL",
  onChange,
  handleSubmit,
}) {
  const channelOptions =
    channelsFilter && channelsFilter.length > 0
      ? channelsFilter.map((channelFilter) => {
          return { name: channelFilter.name, value: channelFilter.value };
        })
      : [];

  const directionOption = useMemo(() => {
    return (
      MESSAGE_DIRECTION_OPTIONS.find((opt) => opt.id === direction) ??
      MESSAGE_DIRECTION_OPTIONS[0]
    );
  }, [direction]);

  const handleChannelsChange = useCallback(
    (channels) => {
      onChange?.({ channels });
    },
    [onChange],
  );

  const handleDirectionChange = useCallback(
    (option) => {
      onChange?.({ direction: option?.id ?? "ALL" });
    },
    [onChange],
  );

  return (
    <Box>
      <Box sx={{ marginBottom: "10px" }}>
        <Box sx={styles.inputDesc}>Date</Box>
        <Box
          sx={{
            "& .MuiStack-root": {
              display: "block !important",
              width: "100% !important",
            },
          }}
        >
          <DateRangeForm
            startDate={startDate}
            endDate={endDate}
            label=""
            setDates={({ startDate: nextStartDate, endDate: nextEndDate }) =>
              onChange?.({ startDate: nextStartDate, endDate: nextEndDate })
            }
          />
        </Box>
      </Box>

      <Box sx={{ marginBottom: "10px" }}>
        <Box sx={styles.inputDesc}>Channels</Box>
        <Box
          sx={{
            "& .select-field": {
              borderRadius: "8px !important",
              height: "45px !important",
              paddingTop: "12px !important",
            },
          }}
        >
          <div
            className={`inbox-context-menu inbox-channel-field ${moduleStyles["channelDropdown"]}`}
          >
            <MultiSelectContextMenu
              displayName={"Channels"}
              options={channelOptions}
              checkedOptions={channelsAction}
              ids={channelsIds}
              handleChange={handleChannelsChange}
            />
          </div>
        </Box>
      </Box>

      <Box>
        <Box sx={styles.inputDesc}>Message Direction</Box>
        <div
          className={`inbox-context-menu inbox-channel-field ${moduleStyles["channelDropdown"]}`}
        >
          <BasicFilterSelect
            placeholder="Select direction"
            options={MESSAGE_DIRECTION_OPTIONS}
            value={directionOption}
            onChange={handleDirectionChange}
            textFieldStyle={styles.organizationSelectInput}
            listBoxHeight={380}
          />
        </div>
      </Box>

      <Box sx={{ marginTop: "30px" }}>
        <BasicButton
          label="Apply"
          style={styles.applyBtnStyles}
          type="button"
          disabled={false}
          action={handleSubmit}
        />
      </Box>
    </Box>
  );
}

const styles = {
  applyBtnStyles: {
    border: "1px solid #003300",
    backgroundColor: "#003300",
    width: "100%",
    color: "#FFFFFF",
    letterSpacing: "-0.5px",
    fontFamily: "FustatBold",
    borderRadius: "5px",
    paddingTop: "10px",
    height: "42px",
  },
  inputDesc: {
    fontFamily: "FustatBold",
    fontSize: "14px",
    fontWeight: 500,
    color: "#495D5E",
    mb: "5px",
  },
  organizationSelectInput: {
    [`& fieldset`]: {
      borderRadius: "8px",
    },
    "& .MuiInputBase-input": {
      height: "12px",
    },
  },
};

export default FilterForm;
